import type { WebLocale } from '@/enums/web-locale';

import { IapWebLocales } from '@/features/jw-pro/constants';

/** Given user pro state and current country, returns if JW Pro is supported. */
export function supportsFreemium(isPro: boolean, webLocale: WebLocale) {
	// show for premium-enabled users, no matter which country is set and for all platforms
	if (isPro) return true;

	if (IapWebLocales.includes(webLocale)) return true;

	// hide in all other cases
	return false;
}
